module.exports = __webpack_public_path__ + "img/ereszkalkulator_25_bilics_merete_jobb_fekete.fd8641f7.png";